import { HttpClient } from 'api/http-client';
import { SpaceTabEmbedMetadata } from 'api/space/space-tab';
import { DocumentTemplate } from '../types';

const NAMESPACE = '/templates';

export interface IframelyError {
  error: string;
  status: 403;
}

class DocumentTemplatesHttpClient extends HttpClient {
  public findAll(): Promise<DocumentTemplate[]> {
    return this.get<DocumentTemplate[]>(`${NAMESPACE}/documents`);
  }

  public embed(url: string) {
    return this.get<string, SpaceTabEmbedMetadata | IframelyError>(
      `${NAMESPACE}/get-iframely-response?url=${url}`,
    );
  }
}

export const DocumentTemplatesAPI = new DocumentTemplatesHttpClient();
